import request from '@/plugins/request';

export function fetchList(query) {
    return request({
        url: '/system/file/page',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/system/file/upload',
        method: 'post',
        data: obj
    })
}

export function getObj(fileName, bucket) {
    return request({
        url: '/system/file/' + bucket + '/' +fileName,
        method: 'get',
    })
}

export function delObj(id) {
    return request({
        url: '/system/file/' + id,
        method: 'delete'
    })
}

export function batchDeleteFile(ids) {
    return request({
        url: '/system/file/batch-delete/' + ids,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/system/file',
        method: 'put',
        data: obj
    })
}
